import gql from 'graphql-tag';

import userFragment from './user-fragment';

export default gql`
  mutation changePasswordUserMutation(
    $password: String!
    $newPassword: String!
    $_id: MongoID!
  ) {
    changePasswordUserMutation(
      password: $password
      newPassword: $newPassword
      _id: $_id
    ) {
      title
      message
      record {
        ...UserFragment
      }
    }
  }
  ${userFragment}
`;
